import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_3 = { class: "md:col-span-12" }
const _hoisted_4 = { class: "rounded-lg border border-slate-200 bg-white p-4" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_6 = { class: "flex min-w-0 flex-col md:col-span-4" }
const _hoisted_7 = { class: "flex min-w-0 flex-col md:col-span-4" }
const _hoisted_8 = { class: "md:col-span-12" }
const _hoisted_9 = { class: "rounded-lg border border-slate-200 bg-white" }
const _hoisted_10 = { class: "grid grid-cols-1 gap-4 p-4 md:grid-cols-12" }
const _hoisted_11 = { class: "flex min-w-0 flex-col md:col-span-4" }
const _hoisted_12 = { class: "flex min-w-0 flex-col md:col-span-4" }
const _hoisted_13 = { class: "flex items-center gap-2" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "m-0 font-medium text-slate-800" }
const _hoisted_16 = { class: "flex min-w-0 flex-col md:col-span-4" }
const _hoisted_17 = { class: "md:col-span-12" }
const _hoisted_18 = { class: "rounded-lg border border-slate-200 bg-white" }
const _hoisted_19 = { class: "grid grid-cols-1 gap-4 p-4 md:grid-cols-12" }
const _hoisted_20 = { class: "flex min-w-0 flex-col md:col-span-4" }
const _hoisted_21 = { class: "flex min-w-0 flex-col md:col-span-4" }
const _hoisted_22 = { class: "flex min-w-0 flex-col md:col-span-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Panel, { header: "Quản lý nhóm" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", null, "Tên nhóm", -1)),
                  _createVNode(_component_InputText, {
                    id: "groupname",
                    type: "text",
                    modelValue: $setup.groupCreate.groupName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.groupCreate.groupName) = $event)),
                    placeholder: "Nhập tên nhóm"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", null, "Thêm nhóm", -1)),
                  _createVNode(_component_Button, {
                    label: "Thêm",
                    icon: "pi pi-plus-circle",
                    iconPos: "left",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.addGroup())),
                    loading: $setup.addingGroup,
                    disabled: !$setup.groupCreate.groupName
                  }, null, 8, ["loading", "disabled"])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "border-b border-slate-200 bg-slate-50 px-4 py-3 text-[15px] font-bold text-slate-900" }, " Thêm thành viên vào nhóm ", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", null, "Chọn nhóm", -1)),
                  _createVNode(_component_Dropdown, {
                    id: "groupselect",
                    modelValue: $setup.idGroup,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.idGroup) = $event)),
                    options: $setup.listGroup,
                    optionLabel: "groupName",
                    optionValue: "id",
                    filter: true
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", null, "Chọn thành viên", -1)),
                  _createVNode(_component_Dropdown, {
                    id: "memberselect",
                    modelValue: $setup.idCustomer,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.idCustomer) = $event)),
                    options: $setup.listCustomer,
                    optionLabel: "name",
                    optionValue: "idMember",
                    filter: true
                  }, {
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_13, [
                        (slotProps.option.imageUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: slotProps.option.imageUrl,
                              class: "mr-1 h-5 w-5 rounded object-cover"
                            }, null, 8, _hoisted_14))
                          : _createCommentVNode("", true),
                        _createElementVNode("label", _hoisted_15, _toDisplayString(slotProps.option.name), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", null, "Thêm thành viên vào nhóm", -1)),
                  _createVNode(_component_Button, {
                    label: "Thêm",
                    icon: "pi pi-plus-circle",
                    iconPos: "left",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.addMember())),
                    loading: $setup.addingMember,
                    disabled: !($setup.idGroup && $setup.idCustomer)
                  }, null, 8, ["loading", "disabled"])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "border-b border-slate-200 bg-slate-50 px-4 py-3 text-[15px] font-bold text-slate-900" }, " Xóa thành viên ra khỏi nhóm ", -1)),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", null, "Chọn nhóm", -1)),
                  _createVNode(_component_Dropdown, {
                    id: "groupselectdelete",
                    modelValue: $setup.idGroupDelete,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.idGroupDelete) = $event)),
                    options: $setup.listGroup,
                    optionLabel: "groupName",
                    optionValue: "id",
                    onChange: $setup.selectGroup,
                    filter: true
                  }, null, 8, ["modelValue", "options", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", null, "Chọn thành viên", -1)),
                  _createVNode(_component_Dropdown, {
                    id: "memberselectdelete",
                    modelValue: $setup.idMemberDelete,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.idMemberDelete) = $event)),
                    options: $setup.memberInGroup,
                    optionLabel: "zaloName",
                    optionValue: "id",
                    filter: true
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", null, "Xóa thành viên ra khỏi nhóm", -1)),
                  _createVNode(_component_Button, {
                    label: "Xóa",
                    icon: "pi pi-trash",
                    iconPos: "left",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.deleteMember())),
                    severity: "danger",
                    loading: $setup.deletingMember,
                    disabled: !($setup.idGroupDelete && $setup.idMemberDelete)
                  }, null, 8, ["loading", "disabled"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}